import React from 'react'
import {Route, Redirect, Switch} from 'react-router-dom'

import useUserContext from 'components/User/useUserContext'

import Landing from 'modules/Landing'
import Login from 'modules/Auth/Login'
import Logout from 'modules/Auth/Logout'
import Register from 'modules/Auth/Register'
import UserProfile from 'modules/UserProfile'
import UserProfileSettings from 'modules/UserProfile/Settings'
import ProductDetailPage from 'modules/ProductDetailPage'

import Components from 'components/Components'

const RouteAuth = ({user, fallback, component, ...props}) => (
  user ? (
    <Route component={component} {...props}/>
  ) : (
    <Route {...props} render={_ => <Redirect to={fallback}/>}/>
  )
)

const Routes = () => {
  const {user} = useUserContext()

  return (
    <Switch>
      <Route exact path='/' component={Landing}/>
      <Route exact path='/login' component={Login}/>
      <Route exact path='/logout' component={Logout}/>
      <Route exact path='/register' component={Register}/>

      <RouteAuth exact path='/profile' component={UserProfile} user={user} fallback='/login'/>
      <RouteAuth exact path='/profile/settings' component={UserProfileSettings} user={user} fallback='/login'/>

      <Route exact path='/product/ean/:ean' component={ProductDetailPage}/>
      <Route exact path='/product/uuid/:merchantUuid/:externalId' component={ProductDetailPage}/>
      <Route exact path='/product/external/:merchantUuid/:externalId' component={ProductDetailPage}/>

      <Route exact path='/components' component={Components}/>
    </Switch>
  )
}

export default Routes
